export default class EducationJwtService {
  axiosIns = null

  jwtConfig = null

  constructor(axiosIns, jwtConfig) {
    this.axiosIns = axiosIns;
    this.jwtConfig = jwtConfig;
  }

  create(payload = {}) {
    return this.axiosIns.post(`${this.jwtConfig.main.educationEndpoint}`, payload)
  }

  update(id, payload = {}) {
    return this.axiosIns.put(`${this.jwtConfig.main.educationEndpoint}/${id}`, payload)
  }

  list(params) {
    return this.axiosIns.get(this.jwtConfig.main.educationEndpoint, {
      params
    })
  }

  delete(id) {
    return this.axiosIns.delete(`${this.jwtConfig.main.educationEndpoint}/${id}`)
  }

  get(id) {
    return this.axiosIns.get(`${this.jwtConfig.main.educationEndpoint}/${id}`)
  }
}
